//el cierre semanal se compone de 3 componentes:
// - CierreSemanalDatos
// - CierreSemanalOtrosDatos
// - CierreSemanalResumen
// Se muestra un componente Stepper de Material-ui que permite cambiar de componente cuando la semana está cerrada. 
// Si la semana no está cerrada, la navegación se hace mediante los botones de guardar de cada uno de estos componentes.

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepButton from '@material-ui/core/StepButton';

import { navigate, openDialog } from '../../actions';

import CierreSemanalDatos from './cierre_semanal_datos';
import CierreSemanalOtrosDatos from './cierre_semanal_otros_datos';
import CierreSemanalResumen from './cierre_semanal_resumen';

import * as config from '../../constants/configuration';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
    stepperContainer: {
        padding: '5px 25px'
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    alternativeLabel: {},
    labelContainer: {
        "& $alternativeLabel": {
            fontWeight: 600,
        }
    },
    icon: {
        color: 'silver',
    },
    textIcon: {
        color: 'white',
        fontWeight: 800
    }
});

class AccCierreSemanal extends Component {


    constructor(props) {
        super(props);
        this.state = {
            activeStep: 0,
            first: true
        };
    };


    componentDidMount() {
        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }
    };


    getSteps = () => {
        return ['Datos Cierre Semanal', 'Otros Datos', 'Resumen y Cierre'];
    };

    getStepContent = (stepIndex) => {
        switch (stepIndex) {
            case 0:
                return <CierreSemanalDatos nextStep={this.handleNext} prevStep={this.handleBack} first={this.state.first}/>;
            case 1:
                return <CierreSemanalOtrosDatos nextStep={this.handleNext} prevStep={this.handleBack} first={this.state.first}/>;
            case 2:
                return <CierreSemanalResumen nextStep={this.handleNext} prevStep={this.handleBack} first={this.state.first}/>;
            default:
                return 'Unknown stepIndex';
        }
    };



    handleNext = () => {
        if (this.state.activeStep + 1 === this.getSteps().length) {
            this.setState(state => ({
                activeStep: 0,
                first: false
            }));
        }
        else {
            this.setState(state => ({
                activeStep: state.activeStep + 1,
                first: false
            }));
        }
    };

    handleStep = step => () => {
        this.setState({
          activeStep: step,
          first: false
        });
      };

    handleBack = () => {
        this.setState(state => ({
            activeStep: state.activeStep - 1,
            first: false
        }));
    };

    handleReset = () => {
        this.setState({
            activeStep: 0,
            first: false
        });
    };

    render() {
        const { classes } = this.props;
        const steps = this.getSteps();
        const { activeStep } = this.state;

        return (
            <div className={classes.root}>
                <div className={classes.toolbar}></div>
                <Stepper activeStep={activeStep} nonLinear alternativeLabel className={classes.stepperContainer}>
                    {steps.map((label, index) => (
                        <Step key={label}>
                            {this.props.centroDiaSelected.isSemanaCerrada ?
                                <StepButton
                                    onClick={this.handleStep(index)}
                                    completed={true}
                                >
                                    {label}
                                </StepButton>
                                :
                                <StepLabel classes={{
                                    alternativeLabel: classes.alternativeLabel,
                                    labelContainer: classes.labelContainer
                                }}
                                    StepIconProps={{ classes: { root: classes.icon, text: classes.textIcon } }}>{label}</StepLabel>
                            }
                        </Step>
                    ))}
                </Stepper>

                {this.getStepContent(activeStep)}

                {/* <div>
                            <Button
                                disabled={activeStep === 0}
                                onClick={this.handleBack}
                                className={classes.backButton}
                            >Back</Button>
                            <Button variant="contained" color="primary" onClick={this.handleNext}>
                                {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                            </Button>
                </div> */}
            </div>
        );
    };

};

AccCierreSemanal.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    centroDiaSelected: PropTypes.object.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        centroDiaSelected: state.centroDiaSelected,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        navigate, openDialog
    }, dispatch);
};


export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(AccCierreSemanal));
